import React, { Component } from "react";
import { profile, GET, PUT, alert, loading, Status } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { cartCount } from "./cart.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "",
      array_link: [],
      user_profile: profile,
      cart_count: cartCount(),
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  syncCart = () => this.setState({ cart_count: cartCount() });
  componentWillUnmount() {
    window.removeEventListener("cart-change", this.syncCart);
    window.removeEventListener("storage", this.syncCart);
  }
  componentDidMount = async () => {
    window.addEventListener("cart-change", this.syncCart);
    window.addEventListener("storage", this.syncCart);
    const { user_profile } = this.state;
    if (user_profile?.expired < new Date().getTime()) {
      localStorage.removeItem("scp-profile");
      alert(
        "/login",
        "warning",
        "แจ้งเตือน",
        "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
      );
    }
  };
  componentMenu = () => {
     const { user_profile, cart_count } = this.state;
    return (
        <div className="navbar-mobile-menu">
            <div className="navbar-mobile-menu__section">
                <a className="navbar-mobile-link" href="/game-uid">
                    เติมเกม UID
                </a>
            </div>
            <div className="navbar-mobile-menu__section">
                <a className="navbar-mobile-link" href="/topup-id-pass">
                    เติมเกม ID-PASS
                </a>
            </div>
            <div className="navbar-mobile-menu__section">
                <a className="navbar-mobile-link" href="/card-topup">
                    บัตรเติมเกม
                </a>
            </div>
            <div className="navbar-mobile-menu__section">
                <a className="navbar-mobile-link" href="/cart" aria-label="ตะกร้า">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>ตะกร้า{cart_count > 0 ? ` (${cart_count})` : ""}
                </a>
            </div>
            {!user_profile ? (
                <div className="navbar-mobile-menu__section">
                    <a className="navbar-mobile-link" href="/login">
                        เข้าสู่ระบบ
                    </a>
                </div>
            ) : (
                <div className="navbar-mobile-menu__section">
                    <button
                        className="navbar-mobile-link navbar-mobile-link--danger"
                        onClick={async () => {
                            if (await alert("", "info", "ออกจากระบบ", "ยืนยันการออกจากระบบหรือไม่", "ออกจากระบบ", "ยกเลิก")) {
                                localStorage.removeItem("scp-profile");
                                window.location.href = "/login";
                            }
                        }}
                    >
                        ออกจากระบบ
                    </button>
                </div>
            )}
            {user_profile && <span>{Status(user_profile?.fullname, "info")}</span>}
        </div>
    );
  };

  render() {
    const { user_profile, cart_count } = this.state;
    return (
      <div className="navbar-shell">
        <Navbar
          className="navbar-premium position-fixed w-100"
          style={{ zIndex: 1000 }}
          expand="xl"
        >
          <div className="container px-3 px-xl-4">
            <Navbar.Brand href="/" className="navbar-brand-premium">
              <div
                className="navbar-brand-premium__wordmark pointer"
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Lvup Topup
              </div>
            </Navbar.Brand>
            <Navbar.Toggle
              className="border-0 navbar-premium__toggle"
              aria-controls="basic-navbar-nav"
            />
            <Navbar.Collapse id="basic-navbar-nav" className="overflow-auto">
              <Nav className="ms-auto py-0">
                <div className="d-none d-xl-flex align-items-center navbar-premium__nav">
                  <a
                    className="navbar-premium__link"
                    href="/game-uid"
                  >
                    เติมเกม UID
                  </a>
                  <a
                    className="navbar-premium__link"
                    href="/topup-id-pass"
                  >
                    เติมเกม ID-PASS
                  </a>
                  <a
                    className="navbar-premium__link"
                    href="/card-topup"
                  >
                    บัตรเติมเกม
                  </a>
                  <a className="navbar-premium__link" href="/cart" aria-label="ตะกร้า">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>ตะกร้า{cart_count > 0 ? ` (${cart_count})` : ""}
                </a>
                   {user_profile && (
                    <span className="navbar-premium__status">
                      {Status(user_profile?.fullname,"info")}
                    </span>
                   )}
                  {!user_profile ?
                 ( <a
                    className="navbar-premium__cta"
                    href="/login"
                  >
                    เข้าสู่ระบบ
                  </a>):(
                     <button
                    className="navbar-premium__cta navbar-premium__cta--danger"
                    onClick={async()=>{if(await alert("","info","ออกจากระบบ","ยืนยันการออกจากระบบหรือไม่","ออกจากระบบ","ยกเลิก")){localStorage.removeItem("scp-profile");window.location.href = "/login";}}}
                  >
                    ออกจากระบบ
                  </button>
                  )
  }
                </div>
                <div
                  className="d-block d-xl-none mb-4 pt-4"
                  style={{ height: "80vh" }}
                >
                  {this.componentMenu()}
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}
